/** @module csi/heading/stateColorResolver */
define([
	"csi/xml"
], function(xml) {
	const PREFIX_CSS = "csi-state csi-state-";
	const MC_STATE = {
		"Draft": "draft",
		"ReleaseToMarkets": "mc-releasetomarkets",
		"ReleaseToCustomers": "mc-releasetocustomers",
		"NotAvailable": "mc-notavailable",
	};
	const SC_STATE = {
		"Draft": "draft",
		"SoldOut": "sc-soldout",
		"NotAvailable": "sc-closed",
	};
	const OPERATIONS_REVIEW_STATE = {
		"Draft": "draft",
		"Pending": "pending",
		"Approved": "approved",
	}
	/** {Object} STYLING_MAP - holds the revision types which need to be customized */
	const STYLING_MAP = {
		"Calendar": {
			0: "incomplete-late",
			1: "incomplete-not-late",
			2: "complete-late",
			3: "complete",
			4: "partial-complete"
		},

		"CamundaProcessDefinitionRevision": {
			"Draft": "draft",
			"Published": "published",
		},

		"DGaaSTemplateRevision": {
			"DRAFT": "draft",
			"APPROVED": "approved",
		},

		"ColorMaterialStatus": {
			"Not Applicable": "not-applicable"
		},

		"Common": {
			"ABANDONED": "revised",
			"APPROVED": "approved",
			"DRAFT": "draft",
			"PENDING": "pending",
			"PENDING2": "review",
			"PROOFING": "proofing",
			"SUBMITTED": "submitted",
			"SUPERSEDED": "superseded",
			"REVIEW": "evaluate",
			"CLOSED": "closed",
		},

		"CustomerPurchaseOrder": {
			"Draft": "draft",
			"Ready": "cpo-ready",
			"Issued": "cpo-issued",
			"Closed": "closed",
			"Abandoned": "revised",
		},

		"EngineeringChange": {
			"Canceled": "ec-canceled",
			"Draft": "draft",
			"Review": "ec-review",
			"Approved": "ec-approved",
		},

		"Factory": OPERATIONS_REVIEW_STATE,

		"FactoryReview": OPERATIONS_REVIEW_STATE,

		"FinalInspection": {
			"Canceled": "closed",
			"Draft": "draft",
			"Planned": "fi-planned",
			"Submitted": "evaluate",
			"InProgress": "fi-in-progress",
			"PartiallyPassed": "fi-passed",
			"Passed": "fi-passed",
			"Failed": "fi-failed",
			"Abandoned": "closed",
		},

		"FinalInspectionBatch": {
			"Draft": "draft",
			"InProgress": "fi-in-progress",
			"WaitingForApproval": "fi-waiting-for-approval",
			"Passed": "fi-passed",
			"PartiallyPassed": "fi-passed",
			"Failed": "fi-failed",
			"Abandoned": "closed",
		},

		"MarketingCollection": MC_STATE,

		"MarketingLook": MC_STATE,

		"MCProduct": MC_STATE,

		"MCProductColor": MC_STATE,

		"MCProductSKU": MC_STATE,

		"ProductStructure": {
			"Draft": "draft",
			"Active": "ps-active",
			"Inactive": "ps-inactive",
		},

		"Project": {
			"Canceled": "pr-canceled",
			"Complete": "pr-complete",
			"Draft": "draft",
			"InProgress": "pr-in-progress",
		},

		"PurchasedOrder": {
			"Draft": "draft",
			"Negotiation": "po-negotiation",
			"Ready": "po-ready",
			"Issued": "po-issued",
			"Closed": "po-closed",
			"Abandoned": "po-abandoned",
		},

		"SalesCollection": SC_STATE,

		"SalesLook": SC_STATE,
		
		"Season": {
			"Complete": "draft",
			"CompletedArchiveDPs": "sr-issued",
			"CompletedArchivePDFs": "sr-issued",
			"MarkedArchived": "sr-complete"
		},

		"SMProduct": SC_STATE,

		"SMProductColor": SC_STATE,

		"SMProductSKU": SC_STATE,

		"StockOrder": {
			"Draft": "draft",
			"Fulfilled": "so-fulfilled",
			"Issued": "so-issued",
			"Accepted": "so-accepted",
			"Canceled": "so-canceled",
		},

		"Supplier": {
			"Approved": "approved",
			"Pending": "pending",
			"Inactive": "su-inactive",
		},

		"SupplierRequest": {
			"Draft": "draft",
			"Generating": "sr-generating",
			"Issued": "sr-issued",
			"Complete": "sr-complete",
			"Failed": "sr-failed",
		},

		"SupplierReview": OPERATIONS_REVIEW_STATE,

		"WbsElement.ScheduleStatus": {
			"Complete": "complete",
			"CompleteLate": "completed-late",
			"Late": "late",
			"PredictedLate": "predicted-late",
		},
	};

	/**
	 * Get the css class by given revision and state
	 * @param {Node} revision
	 * @return {string}
	 */
	function getStateCss(revision) {
		if (!revision) {
			return "";
		}

		const type = revision.$Type;
		const state = revision.State || revision.InspectionState || revision.InspectionBatchState || (type === "Season" ? revision.Status : null);
		const stateEnumValue = xml.enumGetText(state);


		// if no match, then just use the "common" styling
		const target = STYLING_MAP[type] || STYLING_MAP["Common"];
		const css = target[stateEnumValue];

		return css ? (PREFIX_CSS + css) : "";
	}

	/**
	 * Get the css class by given type and index
	 * @param {string} type
	 * @param {number} index
	 * @return {string}
	 */
	function getStateCssByIndex(type, index) {
		const target = STYLING_MAP[type];

		if (!target) {
			return "";
		}

		const css = target[index];
		return css ? (PREFIX_CSS + type.replace(".", "-").toLowerCase() + "-" + css) : "";
	}

	/**
	 * Get the css class by given index from common type
	 * @param {number} index
	 * @return {string}
	 */
	function getStateCssByIndexFromCommon(index) {
		const target = STYLING_MAP["Common"];
		const css = target[index];
		return css ? (PREFIX_CSS + css) : "";
	}

	return {
		getStateCss,
		getStateCssByIndex,
		getStateCssByIndexFromCommon,
	};
});